import { render, staticRenderFns } from "./ManageInvitations.vue?vue&type=template&id=4ad0df51&scoped=true&"
import script from "./ManageInvitations.vue?vue&type=script&lang=js&"
export * from "./ManageInvitations.vue?vue&type=script&lang=js&"
import style0 from "./_ManageInvitations.scss?vue&type=style&index=0&id=4ad0df51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0df51",
  null
  
)

export default component.exports